import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

import Search from '../Search/Search';

class Home extends Component {
  render() {
    return (
      <div className="min-height-div" >
        <Container className="mt-5">
          <Row>
            <Col>
              <h1 id="home-tagline" className="home text-center mt-5">Search Technopedia.com - Beta</h1>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col sm="12" md={{ size: 8, offset: 2 }}>
              <Search />
            </Col>
          </Row>
        </Container>
        <div className="img-background" />
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js